/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Text_To_SpeechInputs */



/**
* | output |
* | --- |
* | "Text To Speech" |
*
* @param {Text_To_SpeechInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const text_to_speech = /** @type {((inputs?: Text_To_SpeechInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Text_To_SpeechInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Synthèse vocale")
	if (locale === "de") return /** @type {LocalizedString} */ ("Text-zu-Sprache-Konvertierung")
	if (locale === "it") return /** @type {LocalizedString} */ ("Testo in voce")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Преобразование текста в речь")
	if (locale === "es") return /** @type {LocalizedString} */ ("Texto a voz")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("文本转语音")
	if (locale === "ja") return /** @type {LocalizedString} */ ("テキスト読み上げ")
	if (locale === "hi") return /** @type {LocalizedString} */ ("भाषण के पाठ")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Texto para fala")
	return /** @type {LocalizedString} */ ("Text To Speech")
});